import { Store } from "vuex"
import { computed, ComputedRef } from "vue"
import store from "store"
import FormService from "features/common/forms/form.service"

export default class EventFormService<F> extends FormService<F> {
  constructor(private store: Store<any>) {
    super()
  }

  _form: ComputedRef<any> = computed(() => this.store.state.event?.eventForm)

  get currentId(): number {
    return this._form.value.id
  }

  _updateForm(key: string, value: any): void {
    store.commit("event/updateEventForm", { [key]: value })
  }
}
